import { IFetchMessageParams, IMessageDto, IPostMessageBody, IUpdateMessageBody } from "@/Models/Chat";
import apiService from "../ApiService";


async function getMessagesByChatId(params: IFetchMessageParams) {
  return await apiService
    .setUrl(`/messages/${params.chatId}`)
    .setMethod("GET")
    .setParams(params)
    .request<IMessageDto[]>();
};
async function postMessage(body: IPostMessageBody) {
  return await apiService
    .setUrl(`/messages`)
    .setMethod("POST")
    .setBody(body)
    .request<IPostMessageBody>();
};
async function updateMessage(body: IUpdateMessageBody) {
  return await apiService
    .setUrl(`/messages`)
    .setMethod("PUT")
    .setBody(body)
    .request<IPostMessageBody>();
};
async function deleteMessageById(id: number) {
  return await apiService
    .setUrl(`/messages/${id}`)
    .setMethod("DELETE")
    .request();
};

const MessageApi = {
  getMessagesByChatId,
  postMessage,
  updateMessage,
  deleteMessageById,
}

export default MessageApi;
